/**
 * @group Constants
 * @internal
 *
 * @summary
 * <blockquote>PostHog service configuration constants</blockquote>
 *
 * @example
 * ```typescript
 * import { POSTHOG_CONFIG } from '@shared/reporting';
 *
 * console.log(POSTHOG_CONFIG.DEFAULT_HOST); // 'https://us.posthog.com'
 * ```
 */
export const POSTHOG_CONFIG = {
  DEFAULT_HOST: 'https://us.posthog.com',
  ENV_API_KEY: 'NEXT_PUBLIC_POSTHOG_KEY',
  ENV_HOST: 'NEXT_PUBLIC_POSTHOG_HOST',
  LOG_PREFIX: '[PostHogService]',
  CLIENT_INIT_STARTED: 'PostHog client initialization started',
  CLIENT_INIT_SUCCESS: 'PostHog client initialized',
  CLIENT_INIT_FAILED: 'Failed to initialize PostHog client',
  BROWSER_CLIENT_LOAD_SUCCESS: 'Browser client loaded',
  BROWSER_CLIENT_INIT_FAILED: 'Failed to initialize browser client',
  NODE_CLIENT_INIT_SUCCESS: 'Node.js client initialized',
  NODE_CLIENT_INIT_FAILED: 'Failed to initialize Node.js client',
  CLIENT_NOT_INITIALIZED: 'PostHog client not initialized'
} as const;
